import {
  Activity,
  Box1,
  Book1,
  Command,
  Danger,
  HomeTrendUp,
  Map1,
  Notification,
  Profile2User,
  Setting2,
  StatusUp,
  TaskSquare
} from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

const dashboard: NavItemType = {
  id: 'group-dashboard',
  title: 'sentinel.nav.dashboard',
  type: 'group',
  url: '/dashboard',
  icon: HomeTrendUp
};

const liveReport: NavItemType = {
  id: 'group-live-report',
  title: 'sentinel.nav.live_report',
  type: 'group',
  url: '/live-report',
  icon: Activity
};

const diagnostics: NavItemType = {
  id: 'group-diagnostics',
  title: 'sentinel.nav.diagnostics',
  type: 'group',
  url: '/system-debug',
  icon: Activity
};

const fleet: NavItemType = {
  id: 'group-fleet',
  title: 'sentinel.nav.fleet',
  type: 'group',
  icon: Box1,
  children: [
    {
      id: 'devices',
      title: 'sentinel.nav.devices',
      type: 'item',
      url: '/devices',
      icon: StatusUp
    },
    {
      id: 'battery-health',
      title: 'sentinel.nav.battery_health',
      type: 'item',
      url: '/battery-health',
      icon: Activity
    },
    {
      id: 'map',
      title: 'sentinel.nav.map',
      type: 'item',
      url: '/map',
      icon: Map1
    },
    {
      id: 'crashes',
      title: 'sentinel.nav.crashes',
      type: 'item',
      url: '/crashes',
      icon: Danger
    }
  ]
};

const operations: NavItemType = {
  id: 'group-operations',
  title: 'sentinel.nav.operations',
  type: 'group',
  icon: Command,
  children: [
    {
      id: 'commands',
      title: 'sentinel.nav.commands',
      type: 'item',
      url: '/commands',
      icon: Command
    },
    {
      id: 'request-types',
      title: 'sentinel.nav.request_types',
      type: 'item',
      url: '/request-types',
      icon: TaskSquare
    },
    {
      id: 'device-models',
      title: 'sentinel.nav.device_models',
      type: 'item',
      url: '/device-models',
      icon: TaskSquare
    },
    {
      id: 'command-rejections',
      title: 'sentinel.nav.command_ota_activity',
      type: 'item',
      url: '/command-rejections',
      icon: Danger
    }
  ]
};

const knowledge: NavItemType = {
  id: 'group-knowledge',
  title: 'sentinel.nav.knowledge',
  type: 'group',
  icon: Book1,
  children: [
    {
      id: 'knowledge-library',
      title: 'sentinel.nav.knowledge_library',
      type: 'item',
      url: '/knowledge',
      icon: Book1
    },
    {
      id: 'knowledge-categories',
      title: 'sentinel.nav.knowledge_categories',
      type: 'item',
      url: '/knowledge/categories',
      icon: TaskSquare
    }
  ]
};

const administration: NavItemType = {
  id: 'group-administration',
  title: 'sentinel.nav.administration',
  type: 'group',
  icon: Setting2,
  children: [
    {
      id: 'customers',
      title: 'sentinel.nav.tenants',
      type: 'item',
      url: '/customers',
      icon: Profile2User
    },
    {
      id: 'push',
      title: 'sentinel.nav.push',
      type: 'item',
      url: '/push',
      icon: Notification
    },
    {
      id: 'ota',
      title: 'sentinel.nav.ota',
      type: 'item',
      url: '/ota',
      icon: Box1
    },
    {
      id: 'announcements',
      title: 'sentinel.nav.announcements',
      type: 'item',
      url: '/announcements',
      icon: Notification
    },
    {
      id: 'update-approvals',
      title: 'sentinel.nav.update_approvals',
      type: 'item',
      url: '/update-approvals',
      icon: TaskSquare
    },
    {
      id: 'update-rollouts',
      title: 'sentinel.nav.update_rollouts',
      type: 'item',
      url: '/update-rollouts',
      icon: TaskSquare
    },
    {
      id: 'users',
      title: 'sentinel.nav.users',
      type: 'item',
      url: '/users',
      icon: Profile2User
    }
  ]
};

const menuItems: { items: NavItemType[] } = {
  items: [dashboard, liveReport, diagnostics, fleet, operations, knowledge, administration]
};

export default menuItems;
